import { FcGoogle } from "react-icons/fc";

/**
 * Visual port of the app's components/GoogleSignInButton.js — same white pill, same
 * copy, just rendered for the web (react-icons/fc's FcGoogle standing in for the
 * native Ionicons "logo-google").
 */
const GoogleSignInButton = ({ onClick, loading = false, label = "Continue with Google", className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={loading}
    className={`w-full inline-flex items-center justify-center gap-3 h-12 px-6 bg-white border border-gray-200 rounded-full shadow-sm hover:shadow-md transition-shadow disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
  >
    {loading ? (
      <svg className="animate-spin h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    ) : (
      <>
        <FcGoogle className="w-5 h-5" />
        <span className="text-gray-700 font-semibold text-sm">{label}</span>
      </>
    )}
  </button>
);

export default GoogleSignInButton;
